import React, { useState, useEffect, useCallback } from "react";
import allTeams from "../data/teams"; // Adjust the import path as necessary
import TeamDisplay from "../component/team/Teamdisplay";
import { useParams } from "react-router-dom";
import ChartWinLoss from "../component/team/chartWinloss";
import ChartPointsAccumulation from "../component/team/chartPointsPerGame";
import Prospects from "../component/team/Prospects";
import TableDataTeam from "../component/team/tableDataTeam";
import ColorScale from "../component/team/chartMui";
import Leaders from "../component/team/leaders";
import TeamStanding from "../component/team/TeamStanding";
import SeasonsStats from "../component/team/SeasonsStats";
import apiUrl from "../config";
import Montly from "../component/schedule/Montly";
import injuriesData from "../data/injuries.js";
import HealingIcon from "@mui/icons-material/Healing";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import AdBanner from "../component/ads/AdBanner";
// Adjusted import to use Firebase storage directly

// const storage = getStorage();
// const injuriesRef = ref(storage, 'injuries.json'); // Or 'injuries/injuries.json' if it's in a folder

// const INJURIES_URL = 'https://firebasestorage.googleapis.com/v0/b/power-edge.firebasestorage.app/o/injuries.json?alt=media&token=313fdaf9-1576-4500-9bfc-f45fedc3453f';
//const INJURIES_URL = injuries;

export default function TeamPage() {
  const [games, setGames] = useState([]);
  const [seasonsGamesStats, setSeasonsStats] = useState([]);
  const { rawTricode } = useParams();
  const [gameType, setGameType] = useState(2);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [nameTeam, setNameTeam] = useState(null);
  const [colorsTeam, setColorsTeam] = useState([]);
  const [loading, setLoading] = useState(true); // State to hold the team's colors
  const [totalPoints, setTotalPoints] = useState(0);
  const [seasonYears, setSeasonYears] = useState<any[]>([]);
  const [prospectsList, setprospectsList] = useState([]);
  const [injuries, setInjuries] = useState(injuriesData);

  const handleTotalPointsUpdate = useCallback((points) => {
    setTotalPoints(points);
  }, []);

  const updateProspects = (list) => {
    setprospectsList(list);
  };

  const getSeasonYears = useCallback(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() is 0-based, so add 1

    if (currentMonth < 9) {
      // If month is less than 10, subtract 1 from the year
      const startYear = currentYear - 1;
      return `${startYear}${currentYear}`;
    } else {
      // If month is 10 or greater, add 1 to the year
      const endYear = currentYear + 1;
      return `${currentYear}${endYear}`;
    }
  }, []);

  const fetchGames = useCallback(async (team) => {
    const season = getSeasonYears();

    try {
      const response = await fetch(
        `${apiUrl}/api/team/stats/${team}/${season}`,
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setGames(data.games || []);
    } catch (error) {
      console.error("Error fetching teams:", error);
      setGames([]);
    }
  }, []);

  const generateYearRanges = useCallback((startRange, count) => {
    const ranges = [];
    let startYear = parseInt(startRange.substring(0, 4)); // Extract the first year (e.g., 2024)

    for (let i = 0; i < count; i++) {
      const endYear = startYear + 1; // Calculate the next year
      ranges.push(`${startYear}${endYear}`); // Create the range (e.g., 20242025)
      startYear--; // Decrement the start year for the next range
    }

    return ranges;
  }, []);

  const fetchSeasons = useCallback(
    async (team) => {
      const seasonNow = getSeasonYears();
      const yearRanges = generateYearRanges(seasonNow, 5);
      setSeasonYears(yearRanges);

      try {
        const results = await Promise.all(
          yearRanges.map(async (season) => {
            const url = `${apiUrl}/api/team/stats/${team}/${season}/`;
            // gameType=2 = saison régulière
            const res = await fetch(url);
            if (!res.ok) throw new Error(`Erreur API saison ${season}`);
            const data = await res.json();
            return { season, data };
          }),
        );
        setSeasonsStats(results);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    },
    [generateYearRanges, getSeasonYears],
  );

  useEffect(() => {
    const selectedTeamObject = allTeams.find(
      (team) => String(team.rawTricode) === String(rawTricode.toUpperCase()),
    );
    if (selectedTeamObject) {
      setSelectedTeam(selectedTeamObject); // Update state with the team's tricode
      setNameTeam(selectedTeamObject.fullName); // Update state with the team's full name
      setColorsTeam(selectedTeamObject.colors); // Update state with the team's colors
      fetchGames(rawTricode); // Fetch games for the selected team
      fetchSeasons(rawTricode); // Fetch games for the selected team
      //            getTeamStats(seasonsStats, selectedTeamObject.rawTricode)
    } else {
      console.warn(`No team found for rawTricode: ${rawTricode}`);
    }
  }, [rawTricode, fetchGames, fetchSeasons]); // Dependency array ensures this runs when rawTricode changes

  useEffect(() => {
    if (games.length > 0) {
      setLoading(true);
      // Process games data if needed
      setLoading(false);

      console.log("Games data updated:", games);
    }
  }, [games]);

  return (
    <div className="wrapper">
      <div className="main">
        <div className="titleTeamPage">
          <div>
            <img
              width={60}
              src={`https://assets.nhle.com/logos/nhl/svg/${rawTricode.toUpperCase()}_dark.svg`}
              alt={`${nameTeam} logo`}
            />
          </div>
          <div>
            <h1>{nameTeam ? `${nameTeam}` : "Select a Team"}</h1>
          </div>
        </div>
        {selectedTeam ? (
          <>
            <div className="teamContent">
              <h2>SEASON STATS</h2>
            </div>
            <div className="teamContent">
              <div className="statsbox">
                <div>
                  <ChartPointsAccumulation
                    games={games}
                    selectedTeam={selectedTeam}
                    gameType={gameType}
                    colorsTeam={colorsTeam}
                  />

                  <div className="legend">
                    <div style={{ background: "#FFD700", color: "#000" }}>
                      Wins
                    </div>
                    <div style={{ background: "#606060", color: "#fff" }}>
                      Losses in OT
                    </div>
                    <div style={{ background: "#454545", color: "#fff" }}>
                      Losses
                    </div>
                    <div style={{ background: "#fff", color: "#000" }}>
                      Playoff Qualification
                    </div>
                  </div>
                </div>
                <div>
                  <TeamStanding
                    selectedTeam={selectedTeam}
                    totalPoints={totalPoints}
                  />
                </div>
              </div>
            </div>
            <div>
              <Montly team={rawTricode} />
            </div>
            <div className="teamContent">
              <div style={{ width: "100%" }}>
                {loading === false && seasonsGamesStats.length > 0 && (
                  <>
                    <SeasonsStats
                      seasons={seasonsGamesStats}
                      selectedTeam={selectedTeam}
                    />
                  </>
                )}
              </div>
            </div>
            <TeamDisplay
              seasonYears={getSeasonYears()}
              selectedTeam={selectedTeam}
              onTotalPointsUpdate={handleTotalPointsUpdate}
              injuries={injuries}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <div>
                <HealingIcon
                  style={{
                    verticalAlign: "bottom",
                    fontSize: "18px",
                  }}
                />{" "}
                = injured
              </div>
              <div>
                <EmojiEventsIcon
                  style={{
                    verticalAlign: "bottom",
                    fontSize: "18px",
                    color: `${colorsTeam[1]}`,
                  }}
                />{" "}
                = Most Points
              </div>
              <div>
                <MilitaryTechIcon
                  style={{
                    verticalAlign: "bottom",
                    fontSize: "18px",
                    color: `${colorsTeam[1]}`,
                  }}
                />{" "}
                = Most Goals
              </div>
              <div>
                <RotateRightIcon
                  style={{
                    verticalAlign: "bottom",
                    fontSize: "18px",
                    color: `${colorsTeam[1]}`,
                  }}
                />{" "}
                = Scratched
              </div>
            </div>
            {/* <Prospects team={rawTricode} selectedTeam={selectedTeam} onTotalPointsUpdate={handleTotalPointsUpdate} updateProspects={updateProspects} /> */}
          </>
        ) : (
          "Team not found"
        )}
      </div>
    </div>
  );
}
